import { render, staticRenderFns } from "./PublicPostPage.vue?vue&type=template&id=2acd69b6&"
import script from "./PublicPostPage.vue?vue&type=script&lang=js&"
export * from "./PublicPostPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports